var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{staticClass:"blur",attrs:{"id":"common_blur"},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }